export default {
  init() {
    // JavaScript to be fired on all pages
	  var options = {
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 1,
		  fade: true,
		  cssEase: 'linear',
		  adaptiveHeight: true,
		  arrows: true,
		  autoplay: false,
		  autoplaySpeed: 10000,
		  prevArrow: $('.js-arrow-left'),
		  nextArrow: $('.js-arrow-right'),
	  };

	  if($('.js-j15-slider').length > 0) {
		  $('.js-j15-slider').slick(options);
	  }

	  $('.js-j15-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		  if($(slick.$slides[nextSlide]).find(".j15-slider__item--white").length > 0 ) {
			  $('.j15-slider__arrow').addClass('j15-slider__arrow--white');
		  } else {
			  $('.j15-slider__arrow').removeClass('j15-slider__arrow--white');
		  }
	  });

	  $(document).on("click", "#astra-mobile-cart-drawer .js-continue-shopping, #astra-mobile-cart-drawer .ast-mini-cart-empty .wc-forward", function (e) {
		  e.preventDefault();

		  $("#astra-mobile-cart-drawer").toggleClass("active");
		  $("html").toggleClass("ast-mobile-cart-active");
	  })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
